import { api } from './client'

const navService = {
  getObjectTypes: async () => {
    const resp = await api.get('/objects/types')
    return resp.data
  },
}

export default navService
